(function(){
  'use strict';
  function cutTest(img){
    try{
      var N=24,c=document.createElement('canvas');c.width=c.height=N;
      var x=c.getContext('2d',{willReadFrequently:true});x.drawImage(img,0,0,N,N);
      var d=x.getImageData(0,0,N,N).data,mn=255,mx=0;
      function at(X,Y){var i=(Y*N+X)*4,l=d[i]*.3+d[i+1]*.59+d[i+2]*.11;if(l<mn)mn=l;if(l>mx)mx=l;}
      for(var k=0;k<N;k++){at(k,0);at(k,N-1);at(0,k);at(N-1,k);}
      return mn>=196&&mx-mn<=22;
    }catch(e){return null;}
  }
  function whenLoaded(img,cb){if(!img){cb();return;}if(img.complete&&img.naturalWidth){cb();return;}img.addEventListener('load',cb,{once:true});img.addEventListener('error',cb,{once:true});}
  function setup(m){
    if(m.__dxbo)return;m.__dxbo=1;
    var L=[].slice.call(m.querySelectorAll('.dxbo__l'));if(!L.length)return;
    var res=[],i=0;
    function done(){
      var mi=-1;for(var k=0;k<res.length;k++){if(res[k]===false){mi=k;break;}}
      if(mi<0){mi=0;}
      var main=L[mi];main.classList.add('is-main');main.classList.toggle('is-cut',res[mi]!==false);
      var ai=mi+1<L.length?mi+1:(mi>0?0:-1);
      if(ai>-1){var A=L[ai],ia=A.querySelector('img');A.classList.add('is-alt','is-cut');whenLoaded(ia,function(){A.classList.toggle('is-cut',cutTest(ia)!==false);});}
    }
    function next(){
      if(i>=L.length){done();return;}
      var im=L[i].querySelector('img');
      whenLoaded(im,function(){res[i]=cutTest(im);if(res[i]===false){i=L.length;done();return;}i++;next();});
    }
    next();
  }
  function initRail(panel){
    if(panel.__dxr)return;panel.__dxr=1;
    var t=panel.querySelector('[data-dxbo-track]'),bar=panel.querySelector('[data-dxbo-bar]');
    var bl=panel.querySelector('.dxbo__arrow--l'),br=panel.querySelector('.dxbo__arrow--r');
    if(!t)return;
    function step(){var c=t.querySelector('.dxbo__card')||t.children[0];return c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(t).columnGap||20):300;}
    [bl,br].forEach(function(b){if(b)b.addEventListener('click',function(){t.scrollBy({left:step()*Number(b.getAttribute('data-dir'))*(window.innerWidth>989?2:1),behavior:'smooth'});});});
    function upd(){var m=t.scrollWidth-t.clientWidth,r=m>0?t.scrollLeft/m:0,vis=t.scrollWidth?t.clientWidth/t.scrollWidth:1,w=Math.max(vis*100,8);
      if(bar){bar.style.width=w+'%';bar.style.left=(r*(100-w))+'%';}
      if(bl)bl.disabled=t.scrollLeft<6;if(br)br.disabled=t.scrollLeft>m-6;}
    t.addEventListener('scroll',function(){requestAnimationFrame(upd);},{passive:true});
    window.addEventListener('resize',upd);upd();
    panel.querySelectorAll('[data-dxbo-m]').forEach(setup);
  }
  function init(s){
    if(s.__dxbo)return;s.__dxbo=1;
    var tabs=s.querySelectorAll('[data-dxbo-tab]');
    tabs.forEach(function(tab){
      tab.addEventListener('click',function(){
        tabs.forEach(function(o){
          var on=o===tab,p=document.getElementById(o.getAttribute('aria-controls'));
          o.classList.toggle('is-on',on);o.setAttribute('aria-selected',on?'true':'false');
          if(p){p.hidden=!on;p.classList.toggle('is-on',on);if(on){initRail(p);var tr=p.querySelector('[data-dxbo-track]');if(tr)tr.scrollLeft=0;}}
        });
        if(window.innerWidth<990)tab.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
      });
    });
    var first=s.querySelector('.dxbo__panel.is-on');if(first)initRail(first);
    s.addEventListener('click',function(e){
      var btn=e.target.closest('[data-dxbo-add]');if(!btn)return;
      e.preventDefault();if(btn.classList.contains('is-load'))return;
      var lab=btn.querySelector('span');btn.classList.add('is-load');
      var cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      var body={id:Number(btn.getAttribute('data-dxbo-add')),quantity:1};
      try{if(cart&&cart.getSectionsToRender){body.sections=cart.getSectionsToRender().map(function(x){return x.id;});body.sections_url=location.pathname;}}catch(err){}
      fetch((s.getAttribute('data-add-url')||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();}).then(function(res){
        if(res.status)throw res;
        btn.classList.remove('is-load');btn.classList.add('is-ok');if(lab)lab.textContent='Ajouté au panier';
        setTimeout(function(){btn.classList.remove('is-ok');if(lab)lab.textContent=lab.getAttribute('data-t')||'Ajouter au panier';},2400);
        var done=false;
        try{if(cart&&cart.renderContents&&res.sections){cart.classList.remove('is-empty');cart.renderContents(res);done=true;}}catch(err){}
        if(!done){fetch('/cart.js').then(function(r){return r.json();}).then(function(c){document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function(x){x.textContent=c.item_count;});}).catch(function(){});}
        document.dispatchEvent(new CustomEvent('dx:cart-added',{detail:res}));
      }).catch(function(){btn.classList.remove('is-load');location.href='/cart';});
    });
  }
  function boot(){document.querySelectorAll('[data-dxbo]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();